import React, { useEffect, useState } from "react";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import useHttp from "../../../hook/use-http";
import NoTableData from "./NoTableData";
import ChartLoader from "./ChartLoader";
import { useNavigate } from "react-router-dom";
import WaterMark from "../DashboardMain_Bus/WaterMark";

export default function CriticalTablesWithDropwon_Bus({ gloablfilter, extraThings }) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [criticalTableData, setCriticalTableData] = useState([]);
  const [TBSelected, setTBSelected] = useState('A')

  const navigate = useNavigate();
  const handleRowClick = (vehicleId) => {
    navigate(`/dashboard_bus/rca_bus/${vehicleId}`);
  };

  const critical_response = (data) => {
    setCriticalTableData(data);
  }

  useEffect(() => {
    setTBSelected(extraThings["packType"])
    // if ('withDropdown' in extraThings) {
    fetchData({ url: API_URL_MAIN + "critical_vehicles_bus/" + extraThings["apiEndPoint"], body: { filterdata: gloablfilter, packType: extraThings["packType"] + extraThings["withDropdown"] } }, critical_response)
    // }
  }, [gloablfilter])

  const changeTB = (selectOp) => {
    setCriticalTableData([]);
    setTBSelected(selectOp);
    fetchData({ url: API_URL_MAIN + "critical_vehicles_bus/" + extraThings["apiEndPoint"], body: { filterdata: gloablfilter, packType: selectOp + extraThings["withDropdown"] } }, critical_response)
  }

  return (
    <>
      <div className="col-lg-3 col-md-6 col-sm-12 mt-3 pr-0">
        <div className="chargingChartboxNew_Bus">
          <div className="v-title chargingTitleChart_Bus">
            <div className="row p-2">
              <div className="col-lg-7 col-md-7 col-sm-7 col-7">
                <b>{extraThings["title"]}</b>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-5 col-5">
                <select className="form-select form-select-sm" aria-label=".form-select-sm example" style={{ marginBottom: "-5px", marginTop: "-5px" }} onChange={(event) => changeTB(event.target.value)} value={TBSelected}>
                  <option value="A">Pack A</option>
                  <option value="B">Pack B</option>
                  <option value="C">Pack C</option>
                  <option value="D">Pack D</option>
                </select>
              </div>
            </div>
          </div>
          <div className="tableContent_Bus px-2" style={{ overflowY: 'scroll', height: '248px' }}>
            <WaterMark />
            <table className="table table-striped">
              <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                <tr>
                  <th scope="col">Vin</th>
                  <th scope="col">{extraThings["withDropdown"].substring(1)}(%)</th>
                </tr>
              </thead>
              <tbody>
                {
                  (isLoading) ? <ChartLoader /> :
                    (criticalTableData.length == 0) ? <NoTableData /> : criticalTableData.map(x => {
                      let item = TBSelected + extraThings["withDropdown"] + "_Value"
                      return (<tr key={x.key.vehicleId}>
                        <td scope="row" className="hand_geture" onClick={() => handleRowClick(x.key.vehicleId)}>{x.key.vehicleId}</td>
                        <td>{x[item].value.toFixed(2)}</td>
                      </tr>)
                    })
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}
